<ui-button
  [block]="true"
  variant="outlined"
  color="secondary"
  (click)="logout()"
  class="mt-3.5 flex items-center justify-center gap-3 rounded-[10px] bg-[#1E1E1E] hover:bg-[#2a2a2a]"
>
  <mat-icon class="text-red-500">exit_to_app</mat-icon>
  <span class="text-red-500 text-[13px]">Cerrar Sesión</span>
</ui-button>
